import type { Database } from 'node-sqlite3-wasm';
import type { DbTagRow } from '../../resolution/types.js';
import type { DbImportRow } from '../sqlite/symbol-index-import-sqlite.js';
import { TAG_SELECT } from '../query/tag-query-shared.js';
import { getEffectiveContentHash, listEffectiveIndexedFilePaths } from './effective-content.js';
import type { SymbolIndexParentContext } from './parent-context.js';

export function loadFileTags(
  db: Database,
  ctx: SymbolIndexParentContext,
  filePath: string,
): DbTagRow[] {
  const contentHash = getEffectiveContentHash(db, ctx, filePath);
  if (contentHash == null) return [];
  return db.all(
    `SELECT ${TAG_SELECT}
     FROM symbol_index_tag
     WHERE content_hash = ? AND file_path = ?
     ORDER BY start_line, start_column`,
    [contentHash, filePath],
  ) as DbTagRow[];
}

export function loadFileImports(
  db: Database,
  ctx: SymbolIndexParentContext,
  filePath: string,
): DbImportRow[] {
  const contentHash = getEffectiveContentHash(db, ctx, filePath);
  if (contentHash == null) return [];
  return db.all(
    `SELECT file_path, local_name, source_name, module_specifier, source_file_path, import_kind, start_line, start_column
     FROM symbol_index_import
     WHERE content_hash = ? AND file_path = ?
     ORDER BY start_line, start_column`,
    [contentHash, filePath],
  ) as DbImportRow[];
}

export function findTagsByName(db: Database, ctx: SymbolIndexParentContext, name: string): DbTagRow[] {
  const filePaths = listEffectiveIndexedFilePaths(db, ctx);
  const rows: DbTagRow[] = [];
  for (const filePath of filePaths) {
    const contentHash = getEffectiveContentHash(db, ctx, filePath);
    if (contentHash == null) continue;
    const matches = db.all(
      `SELECT ${TAG_SELECT}
       FROM symbol_index_tag
       WHERE content_hash = ? AND file_path = ? AND name = ?
       ORDER BY start_line, start_column`,
      [contentHash, filePath, name],
    ) as DbTagRow[];
    rows.push(...matches);
  }
  rows.sort((a, b) =>
    a.file_path.localeCompare(b.file_path) ||
    a.start_line - b.start_line ||
    a.start_column - b.start_column,
  );
  return rows;
}
